export const CARD_SIZE = 114
export const HAND_SIZE = 56
export const DISCARD_SIZE = 44
export const GAME_WIDTH = 1024
export const GAME_HEIGHT = 768
export const CURSOR_SIZE = 80
